<template>
  <div v-if="dataRetrived">
    <v-card>
      <v-layout pt-12></v-layout>
      <v-layout pt-12></v-layout>
      <v-layout wrap pt-12 justify-center>
        <v-flex xs12 md2 align="center">
          <v-img src="../../assets/icons/tick.png" aspect-ratio="1" contain height="50px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 md12 text-center>
          <span style="font-size:18px;color:#000;font-weight:400">{{msg}}</span>
        </v-flex>
      </v-layout>
      <v-layout wrap justify-center>
        <v-flex xs12 md3 align="center">
          <v-img src="../../assets/person.png" contain height="300px">
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<script>
export default {
  props: ["successData"],
  data() {
    return {
      dataRetrived: false
    };
  },
  mounted() {
    this.msg = this.successData.msg;
    this.dataRetrived = true;
    // this.heading=successData.heading
  }
};
</script>